import React from "react";
import IconMC from "../../components/IconMC";
import TitleMC from "../../components/TitleMC";

const RightModalHeader = ({
  title,
  caption,
  showBackButton,
  onClose
}) => (
  <div>
    <div className={`tw-flex tw-justify-between tw-items-center tw-border-b ${showBackButton ? 'tw-px-4' : 'tw-px-6'} ${caption ? 'tw-py-2' : 'tw-py-4 tw-items-center'}`}>
      <div className="tw-flex tw-justify-center">
        {showBackButton && (
          <IconMC
            name="chevron-left-fill"
            onClick={onClose}
            className="tw-text-gray-600 tw-mr-1"
          />
        )}
        <div className={`tw-flex ${caption ? 'tw-flex-col' : ''}`}>
          {caption && <span className="tw-text-gray-500 tw-text-sm">{caption}</span>}
          {title && <TitleMC text={title} textClassName="tw-text-base tw-font-semibold tw-text-gray-600" />}
        </div>
      </div>
      {!showBackButton && (
        <div className="tw-flex tw-items-center">
          <IconMC
            name="close-outline"
            onClick={onClose}
          />
        </div>
      )}
    </div>
  </div>
);

export default RightModalHeader;
